import { Product } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import { recalculateProductsOnPropertiesChange } from './recalculateProductsOnPropertiesChange';

export const remapProductsForAppliedAcreage = (
  products: Product[],
  totalAppliedAcreage: number,
  tankCount?: number
): Product[] => {
  const nonCarrierProducts = products.filter(product => !product.isCarrier);
  const recalculatedNonCarrierProducts = recalculateProductsOnPropertiesChange(
    nonCarrierProducts,
    totalAppliedAcreage,
    { tankCount }
  );

  let nonCarrierIndex = 0;

  return products.map(product => {
    if (!product.isCarrier) {
      const recalculatedProduct =
        recalculatedNonCarrierProducts[nonCarrierIndex];
      nonCarrierIndex += 1;

      return recalculatedProduct;
    }

    return {
      ...product,
      totalAppliedAcreage,
      // For carrier products, the coverage is always 100%, so appliedAreaValue is the same as totalAppliedAcreage
      appliedAreaValue: totalAppliedAcreage
    };
  });
};

export default remapProductsForAppliedAcreage;
